import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Select from "react-select";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'react-hot-toast';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

function PlanDeposit1() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lsType = localStorage.getItem('upgrade.type');
    const hasType = state?.type || lsType;
    if (!hasType) {
      navigate('/plandeposit', { replace: true });
    } else {
      setLoading(false);
    }
  }, [state, navigate]);
    const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [methodoptions, setMethodoptions] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchaddress: true })
    })
    .then(response =>  response.json())
    .then(data => {
      const methodop = []
      if (data.status === "success") {
        data.address.forEach(address => {
          var netlist = JSON.parse(address.network);
          methodop.push({
            value: address.value,
            logo: address.logo,
            label: (
              <>
                <img src={address.logo} alt={address.symbol} width="20" style={{ marginRight: 5 }} />
                {address.value}
              </>
            ),
            address: address.address,
            network: netlist,
            symbol: address.symbol,
            price: address.price
          });
        });
        setMethodoptions(methodop); 
      }
    })
    .catch(err => {
      console.error('Error fetching deposit wallet:', err);
    })
  }, [user]);
  const [fee, setFee] = useState(() => {return state?.fee ?? localStorage.getItem('withdraw.fee');});
  const [feeamount, setFeeAmount] = useState(() => {return state?.feeamount ?? localStorage.getItem('withdraw.feeamount');});
  const [stockAmount, setStockAmount] = useState(() => {return localStorage.getItem('stock.amount');});
  const [stock, setStock] = useState(() => {return localStorage.getItem('stock.stock');});
  const [plan, setPlan] = useState(() => {return state?.plan ?? localStorage.getItem('upgrade.plan');});
  const [planamount, setPlanamount] = useState(() => {return state?.planamount ?? localStorage.getItem('upgrade.planamount');});
  const [type, setType] = useState(() => {return state?.type ?? localStorage.getItem('upgrade.type') ?? 'crypto';});
  const [method, setMethod] = useState(localStorage.getItem('upgrade.method') || '');
  const [symbol, setSymbol] = useState(localStorage.getItem('upgrade.symbol') || '');
  const [price, setPrice] = useState(0);
  const [address, setAddress] = useState(localStorage.getItem('upgrade.address') || '');
  const [disable, setDisable] = useState(true);
  const [qrCode, setQrCode] = useState(localStorage.getItem('upgrade.qrCode') || '');
  const [network, setNetwork] = useState(localStorage.getItem('upgrade.network') || '');
  const [networklist, setNetworkList] = useState([]);
  const [amount, setAmount] = useState(localStorage.getItem('upgrade.amount') || '');
  const ValidateNetwork = (allnetwork) => {
    if (!Array.isArray(allnetwork) || allnetwork.length === 0) {
      setNetworkList([]);
      setNetwork('');
      setAddress('');
      setQrCode('');
      return;
    }
    const options = allnetwork.map(net => ({ value: net, label: net }));
    setNetworkList(options);
    setNetwork('');
    setAddress('');
    setQrCode('');
  }
  const UpdateAddress = (networkValue) => {
    if (!method || !networkValue || !Array.isArray(methodoptions)) return;
    const match = methodoptions.find(m => (m.symbol === method || m.value === method));
    if (!match) {
      setAddress('');
      setQrCode('');
      setNetwork('');
      return;
    }
    let addrMap = {};
    try {
      addrMap = typeof match.address === 'string' ? JSON.parse(match.address) : match.address;
    } catch (err) {
      addrMap = {};
    }
    const addr = addrMap[networkValue] || '';
    setAddress(addr);
    setQrCode(addr);
  }
  const handleCopy = async () => {
    if (!address) return;
    try {
        await navigator.clipboard.writeText(address);
        toast.success('Copied to Clipboard!')
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
  };
  useEffect(() => {
    const asset = methodoptions.find((opt) => opt.value === method);
    if(asset){
      setPrice(asset.price);
    }
    const calculate = (value) => {
      const price = Number(asset?.price || 0);
      return price ? Number((Number(value) / price).toFixed(6)) : 0;
    };
    if (fee && fee !== 'null' && feeamount && feeamount !== 'null' && asset) {
      setAmount(calculate(feeamount));
    } 
    else if (stock && stock !== 'null' && stockAmount && stockAmount !== 'null' && asset) {
      setAmount(calculate(stockAmount / rate));
    }else if (plan && plan !== 'null' && planamount && planamount !== 'null' && asset) {
      setAmount(calculate(planamount));
    }
  }, [fee, feeamount, planamount, plan, stock, stockAmount, method, methodoptions]);
  useEffect(() => {
    if(symbol && address && qrCode && method && network && amount){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [symbol, address, qrCode, method, network, amount]);
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Make a Deposit</h5>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/plandeposit" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Method</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/plandeposit1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Details</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Payment Proof</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/plandeposit3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12 largeSelect">
                                <label className="fw-semibold mb-1">Select Crypto to deposit</label>
                                <Select 
                                    options={methodoptions} 
                                    value={methodoptions.find((opt) => opt.value === method)}
                                    onChange={(selected) => {
                                        setMethod(selected.value);
                                        setSymbol(selected.symbol);
                                        setPrice(selected.price);
                                        setAddress('');
                                        setQrCode('');
                                        setNetwork('');
                                        setNetworkList([]);
                                        ValidateNetwork(selected.network);
                                    }}
                                    isSearchable
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                                <hr/>
                                <label className="fw-semibold mb-1">Select {symbol ? symbol : null} deposit network</label>
                                <Select 
                                    options={networklist} 
                                    value={networklist.find((opt) => opt.value === network) || null} 
                                    onChange={(selected) => {
                                        UpdateAddress(selected.value);
                                        setNetwork(selected.value);
                                    }}
                                    isSearchable
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                                <div className="mycard p-3 rounded-2 mt-3" style={{backgroundColor:'#ff6b350d'}}>
                                    <p className="mb-0 text-prime" style={{fontSize:'14px'}}>Tip: Double‑check the network tag (e.g., ERC20, TRC20, BEP20) matches your wallet/exchange before proceeding.</p>
                                </div>
                                <label className="fw-semibold mb-1 mt-2">Amount</label>
                                {(fee && fee !== 'null' && feeamount && feeamount !== 'null' && price)  ? (
                                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                    <input 
                                    type="number"
                                    placeholder="0.00000000"
                                    className="inputNone"
                                    value={(Number(feeamount) / price).toFixed(6)}
                                    readOnly
                                    />
                                    <div
                                    className="fw-bold text-white d-flex align-items-center"
                                    style={{
                                        backgroundColor: 'rgb(30, 33, 36)',
                                        borderRadius: '4px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        cursor: 'pointer'
                                    }}
                                    >
                                    {symbol}
                                    </div>
                                </div>
                                ) : (stock && stock !== 'null' && stockAmount && stockAmount !== 'null' && price) ? (
                                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                    <input 
                                      type="number"
                                      placeholder="0.00000000"
                                      className="inputNone"
                                      value={(Number(stockAmount / rate) / price).toFixed(6)}
                                      readOnly
                                    />
                                    <div
                                    className="fw-bold text-white d-flex align-items-center"
                                    style={{
                                        backgroundColor: 'rgb(30, 33, 36)',
                                        borderRadius: '4px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        cursor: 'pointer'
                                    }}
                                    >
                                    {symbol}
                                    </div>
                                </div>
                                ) : (plan && plan !== 'null' && planamount && planamount !== 'null' && price) ? (
                                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                    <input 
                                      type="number"
                                      placeholder="0.00000000"
                                      className="inputNone"
                                      value={(Number(planamount) / price).toFixed(6)}
                                      readOnly
                                    />
                                    <div
                                    className="fw-bold text-white d-flex align-items-center"
                                    style={{
                                        backgroundColor: 'rgb(30, 33, 36)',
                                        borderRadius: '4px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        cursor: 'pointer'
                                    }}
                                    >
                                    {symbol}
                                    </div>
                                </div>
                                ) : (
                                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                    <input 
                                    type="number"
                                    placeholder="0.00000000"
                                    className="inputNone"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    />
                                    <div
                                    className="fw-bold text-white d-flex align-items-center"
                                    style={{
                                        backgroundColor: 'rgb(30, 33, 36)',
                                        borderRadius: '4px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        cursor: 'pointer'
                                    }}
                                    >
                                    {symbol}
                                    </div>
                                </div>
                                )}
                                <hr/>
                                <label className="fw-semibold mb-1">Deposit Address</label>
                                <div className="d-flex align-items-start" style={{gap:'20px'}}>
                                    <div className="rounded-3 p-2 d-flex align-items-center justify-content-center QRCodeSVG" style={{height:'150px',width:'150px',border:'1px solid #a9a9a90f'}}>
                                        <QRCodeSVG
                                            value={qrCode}
                                            size={150}
                                            bgColor="#ffffff"
                                            fgColor="#000000"
                                            level="M"
                                        />
                                    </div>
                                    <div className="flex-grow-1">
                                        <p className="mb-2" style={{fontSize:'14px'}}>{symbol ? symbol : 'Cryptocurrency'} Address</p>
                                        <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1 w-100">
                                            <input 
                                                type="text"
                                                readOnly
                                                className="inputNone"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                            />
                                            <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}} onClick={handleCopy}>Copy</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    {disable ? (
                                        <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                    ) : (
                                        <Link to="/plandeposit2" 
                                        state={{
                                          symbol,
                                          address,
                                          plan,
                                          amount,
                                          method,
                                          network,
                                          type
                                        }}
                                        onClick={() => {
                                          localStorage.setItem('upgrade.symbol', symbol);
                                          localStorage.setItem('upgrade.address', address);
                                          localStorage.setItem('upgrade.amount', amount);
                                          localStorage.setItem('upgrade.method', method);
                                          localStorage.setItem('upgrade.network', network);
                                          localStorage.setItem('upgrade.qrCode', qrCode);
                                        }}
                                        className="myBtn mt-4 text-center px-4 py-3 rounded-2">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}}/></Link>
                                    )}
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default PlanDeposit1